import React, { useEffect, useState } from 'react';
import { HourglassIcon } from 'lucide-react';
type UrgencyBannerProps = {
  minutosIniciales: number;
};
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function UrgencyBanner({
  minutosIniciales
}: UrgencyBannerProps) {
  const [restante, setRestante] = useState(minutosIniciales * 60 + 24);
  useEffect(() => {
    setRestante(minutosIniciales * 60 + 24);
  }, [minutosIniciales]);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRestante(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const minutos = Math.floor(restante / 60);
  const segundos = restante % 60;
  return <div className="sticky top-0 z-40 w-full border-b border-line bg-[#1B0F2E]" data-id="element-175" data-mp="3b77oy7v5iog6">
      <div className="mx-auto flex max-w-content flex-wrap items-center justify-center gap-x-4 gap-y-1 px-5 py-2.5 text-center" data-id="element-176" data-mp="1bvwxjygx19o1">
        <span className="inline-flex items-center gap-2 text-[13px] font-medium tracking-wide text-cream" data-id="element-177" data-mp="1gurojnp1e4j8">
          <HourglassIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-178" data-mp="27g12zoamcgdc" />
          La oferta especial vence en:
        </span>
        <span className="font-sans text-[15px] font-semibold tabular-nums text-gold" aria-live="off" data-id="element-179" data-mp="1xonai0h34gtp">
          {pad(minutos)} min : {pad(segundos)} seg
        </span>
      </div>
    </div>;
}